export default "__VITE_ASSET__DgzjqHT5__"